import React, { useState } from 'react'
import { Grid, Typography, Modal } from '@material-ui/core/'
import { DialogModal, Button } from 'components/UI/'
import closeIcon from '../../../../../../assetss/img/closeModalIcon.svg'
import apiChat from '../../../../../../api/chat'
import './index.scss'

const FeadbackAccept = ({ open, setOpen }) => (
  <Modal
    open={open}
    onClose={setOpen}
  >
    <div className='modalFeeatbackAccept' onClick={setOpen}>
      <div className='textAccept'>
        <img className='iconClose' src={closeIcon} onClick={setOpen} />
        Thanks for sharing your feedback!
      </div>
    </div>
  </Modal>
)

const FailedReview = ({ openReview, setOpenReview, name, accessKey, meeting, getMeeting }) => {
  const [open, setOpen] = useState(false)

  const titleBtn = ['We postponed the meeting', 'The person didn\'t show up', 'We cancelled it', 'Other']

  const sendReview = item => {
    apiChat.sendReviewFailure(
      accessKey,
      meeting?.uuid,
      item,
    ).then(() => {
      setOpenReview(false)
      setOpen(true)
      getMeeting()
    })
  }

  return (
    open ? (
      <FeadbackAccept open={open} setOpen={() => setOpen(false)} />
    ) : (
      <DialogModal
        open={openReview}
        onClose={() => setOpenReview(false)}
        closeBtn
        height='410px'
        width='320px'
      >
        <Grid className='boxFeadbackMeet'>
          <Typography className='titleName'>Why the meeting didn't take place?</Typography>
          {titleBtn?.map((i, ind) => (
            <Button key={ind} className={ind === 3 ? 'nextBtnFailed' : 'nextBtn'} onClick={() => sendReview(ind)}>
              {i}
            </Button>
          ))}
        </Grid>
      </DialogModal>
    )
  )
}

export default FailedReview
